import { api } from './api';

export type SignalType =
  | 'striking_distance'
  | 'ctr_gap'
  | 'quality_bounce'
  | 'content_gap'
  | 'decay'
  | 'cwv';

export type SignalStatus = 'open' | 'in_progress' | 'resolved' | 'dismissed';

export interface ContentSignal {
  id: string;
  site: string;
  wp_post_id: string;
  signal_type: SignalType;
  severity: 'high' | 'medium' | 'low';
  score: number;
  ref_key: string; // a query, quando aplicável
  payload: Record<string, unknown>;
  status: SignalStatus;
  detected_at: string;
}

export interface SuggestResult {
  target: string;
  variations: { title: string; meta: string }[];
}

export const optimizationApi = {
  list: (
    params: { site?: string; type?: SignalType; status?: SignalStatus; limit?: number } = {},
  ) => {
    const qs = new URLSearchParams();
    if (params.site) qs.set('site', params.site);
    if (params.type) qs.set('signal_type', params.type);
    qs.set('status', params.status ?? 'open');
    if (params.limit) qs.set('limit', String(params.limit));
    return api.get<ContentSignal[]>(`/metrics/signals?${qs.toString()}`);
  },
  suggest: (id: string) => api.post<SuggestResult>(`/metrics/signals/${id}/suggest`, {}),
  apply: (id: string, body: { title: string; meta?: string }) =>
    api.post<{ ok: boolean; status: string }>(`/metrics/signals/${id}/apply`, body),
  setStatus: (id: string, status: SignalStatus) =>
    api.patch<ContentSignal>(`/metrics/signals/${id}`, { status }),
  recompute: (site: string) =>
    api.post<{ signals: number }>(
      `/metrics/signals/recompute?site=${encodeURIComponent(site)}`,
      {},
    ),
  cwvSync: (site: string, limit = 12) =>
    api.post<{ measured: number }>(
      `/metrics/cwv/sync?site=${encodeURIComponent(site)}&limit=${limit}`,
      {},
    ),
};
